module.exports = __webpack_public_path__ + "img/l_OBJC.2ee32c2c.svg";